<template>
    <Modal :is_show="is_show" @click-bg="close()" class="add-creator-modal add-title-modal edit-program-set-pop">
        <header class="edit_program_header">About Application <i @click="close()"><svg-icon name="close" /></i>
        </header>
        <Scrollbar class="edit-scroll-list" :show_bar="true">
            <div class="edit_program_body">
                
                <div class="box question-templeat">
                    
                    <div class="edit-item" :key="key_ref">
                        <!-- title -->
                        <div class="line">
                            <div class="name">{{data[ind.application_title.i].question[ind.application_title.ii].name}}<div class="red">*</div></div>
                        </div>
                        <Field :type="data[ind.application_title.i].question[ind.application_title.ii].client_view.client_type" :k="data[ind.application_title.i].question[ind.application_title.ii].label" :placeholder="data[ind.application_title.i].question[ind.application_title.ii].client_view.plac" 
                            @update="update" :had_value="data[ind.application_title.i].question[ind.application_title.ii].client_view.val"/>
                        
                        <!-- summary -->
                        <div class="line">
                            <div class="name">{{data[ind.summary.i].question[ind.summary.ii].name}}</div>
                            <div class="handle_req" >
                                <Switch :checked="data[ind.summary.i].is_switch" @click.native="data[ind.summary.i].is_switch = data[ind.summary.i].is_switch ? false : true" />
                            </div>
                        </div>
                        <Field v-if="data[ind.summary.i].is_switch" :type="data[ind.summary.i].question[ind.summary.ii].client_view.client_type" :k="data[ind.summary.i].question[ind.summary.ii].label" :placeholder="data[ind.summary.i].question[ind.summary.ii].client_view.plac" 
                            @update="update"  :had_value="data[ind.summary.i].question[ind.summary.ii].client_view.val"/>
                    </div>
                </div>
            </div>
        </Scrollbar>
        
        <!-- save -->
        <div class="save-btn-box">
            <Button class="save-btn" size="40" color="dark-blue" :border_r="6" @click="save" :is_disabled="!temp_data.application_title">
                Save
            </Button>
        </div>
    </Modal>

</template>

<script>
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Switch from '@/components/ui/Switch.vue';
import { dataTool } from 'echarts';
import Checkbox from '@/components/ui/Checkbox.vue';
import * as yup from 'yup';
import moment from 'moment';
import { getIndex } from '@/utils/ProgramsData.js';

export default {
    name: 'ProgramForm',
    emits: ['close','save'],

    data() {
        return {
            temp_data:{
                application_title:'',
                summary:'',
                switch:false,
            },
            //data_index
            ind:{
                application_title:{ii:0,i:0},
                summary:{ii:0,i:0},
            },
            key_ref:0,
        }
    },

    props: {
        is_show: {
            type: Boolean,
            default: true,
        },
        data: {
            type: Array,
            default: []
        },
        is_edit: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
    },

    watch:{

    },

    components: {
        Scrollbar,
        Field,
        Button,
        Form,
        Modal,
        NoData,
        Loading,
        Dropdown,
        Switch,
        Checkbox,
    },

    watch: {

    },

    methods: {
        update(obj) {
            Object.keys(this.temp_data).forEach(key => {
                if (key === obj.key) {
                    if (key === obj.key) this.temp_data[key]= obj.val;
                }
            });
        },

        save(){
            this.setDate();
            //console.log('this.data',this.data)
            this.$emit('save',{data:this.data,type:'title'})
        },

        close(){
            this.data[this.ind.summary.i].question[this.ind.summary.ii].is_switch=this.temp_data.switch;
            this.$emit('close');
        },
        
        setDate() {
            this.data[this.ind.application_title.i].question[this.ind.application_title.ii].client_view.val=this.temp_data.application_title;
            this.data[this.ind.summary.i].question[this.ind.summary.ii].client_view.val=this.data[this.ind.summary.i].is_switch ? this.temp_data.summary:'';
            this.data[this.ind.summary.i].question[this.ind.summary.ii].is_switch=this.data[this.ind.summary.i].is_switch;
            this.data[this.ind.summary.i].question[this.ind.summary.ii].show=this.data[this.ind.summary.i].is_switch;
        }
    },


    mounted() {
        //make sure index won't change
        this.ind={
            application_title:getIndex(this.data,'title','application_title'),
            summary:getIndex(this.data,'summary','summary'),
        }

        this.temp_data.application_title=this.data[this.ind.application_title.i].question[this.ind.application_title.ii].client_view.val;
        this.temp_data.summary=this.data[this.ind.summary.i].question[this.ind.summary.ii].client_view.val;
        this.temp_data.switch=this.data[this.ind.summary.i].is_switch;
        this.key_ref+=1;
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.add-title-modal{
    .edit-item{
        margin-top:8px !important;
    }

    .edit-scroll-list{
        overflow: unset !important;
    }
}
</style>